import styled from 'styled-components'

export const HeaderElem = styled.header<{ $headerHeight: string }>`
  position: relative;
  min-height: 180px;
  padding: 80px 100px 0;
  height: ${({ $headerHeight }) => $headerHeight};
`
export const HeaderLogo = styled.img`
  position: absolute;
  top: 64px;
  left: 0;
  width: 240px;
`
export const Title = styled.h2`
  font-size: 40px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.register.title};
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 24px;
  text-align: center;
`
export const Description = styled.p`
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 65px;
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
  color: ${(props) => props.theme.colors.register.text};
`
